
export const AUTH_DATABASE_NAME = 'ua-canada-db';
export const OFFLINE_DATABASE_NAME = 'offline-db';
export const UA_CANADA_DATABASE_NAME = 'ua-canada-db';
export const AUTH_STORE_NAME = 'auth';
export const USER_MANAGEMENT_DATABASE_NAME = 'user-management-db';
export const JOBSITES_DATABASE_NAME = 'jobsites-db';
export const USERS_DATABASE_NAME = 'UsersDB';
export const USERS_STORE_NAME = 'users';
export const USERS_TEST_STORE_NAME = 'usersTest';
export const UNSYNCED_USERS_STORE_NAME = 'unsyncedUsers';
export const JOBSITES_STORE_NAME = 'jobsites';
export const UNSYNCED_JOBSITES_STORE_NAME = 'unsyncedJobsites';
export const ROLES_STORE_NAME = 'roles';
export const REQUESTS_STORE_NAME = 'requests';
export const LOOKUPS_STORE_NAME = 'lookups';
export const CONTRACTORS_STORE_NAME = 'contractors';
export const JOBSITE_DETAILS_STORE_NAME = 'jobsiteDetails';
export const JOBSITE_ADDRESS_STORE_NAME = 'jobsiteAddress';
export const JOBSITE_WORKERS_STORE_NAME = 'jobsiteWorkers';
export const JOBSITE_FILES_STORE_NAME = 'jobsiteFiles';
export const JOBSITE_TRADES_STORE_NAME = 'jobsiteTrades';
export const JOBSITE_SUBMIT_STORE_NAME = 'jobsiteSubmit';
export const JOBSITE_MARK_AS_COMPLETE_STORE_NAME = 'jobsiteMarkAsComplete';
export const JOBSITE_COMMENTS_STORE_NAME = 'jobSiteComments';
export const JOBSITE_DELETE_STORE_NAME = 'jobSiteDelete';
export const NEW_RECORD = 'new_';
export const MAPS_CACHE_NAME = 'maps-cache';
export const JOBSITE_STATUS_ACTIVE = 'active';
export const JOBSITE_STATUS_INACTIVE = 'inactive';
export const JOBSITE_STATUS_COMPLETED = 'completed';
export const JOBSITE_FILES_DELETE_STORE_NAME = 'jobsiteFilesDelete';
